<script lang="ts">
  import { untrack, onMount } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import type { InboxWorkflowRowEditorProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { WrongRecipientReplacementRow, WrongRecipientReplacementDraft } from "../../contract"
  import { ContactComparisonTag } from "../../../../../../_shared/_modules/contact-comparison-tag"
  import { ContactPersonForm } from "../../../../../../_shared/_modules/contact-person-form"
  import type { ContactPersonDraft } from "../../../../../../_shared/_logic/contact-comparison"
  import { previousComparisons, validateDraft } from "../../_shared/_logic/comparison"
  let {
    row,
    draft,
    disabled,
    save,
    onshowOverlay,
    setActionButtonSnippet,
  }: InboxWorkflowRowEditorProps<WrongRecipientReplacementRow, WrongRecipientReplacementDraft> =
    $props()
  let value = $state<ContactPersonDraft>(
    untrack(() => ({
      displayName: draft.displayName,
      role: draft.role,
      email: draft.email,
      phone: draft.phone,
    })),
  )
  let error = $state<string | null>(null)
  const saveDraft = () => {
    const patch = {
      ...draft,
      ...value,
      role: value.role as WrongRecipientReplacementDraft["role"],
      fieldMeta: Object.fromEntries(
        Object.entries(draft.fieldMeta).map(([field, meta]) => [
          field,
          {
            ...meta,
            currentSource:
              value[field as keyof ContactPersonDraft] === draft[field]
                ? meta.currentSource
                : value[field as keyof ContactPersonDraft]
                  ? "manual"
                  : "none",
          },
        ]),
      ) as WrongRecipientReplacementDraft["fieldMeta"],
    }
    error = validateDraft(row, { ...draft, ...patch })

    if (!error) error = save(patch)
  }
  onMount(() => {
    const registerActions = setActionButtonSnippet
    registerActions?.(footerSnippet)
    onshowOverlay?.()

    return () => registerActions?.(null)
  })
</script>
{#snippet footerSnippet()}
  <div class="editor-actions">
  <CTA
      type="primaryButton"
      content="Speichern"
      darkMode={false}
      {disabled}
      onclick={saveDraft}
      tooltipContent="Speichert den Entwurf in dieser Zeile. Übernommen wird er anschließend mit der Batch-Aktion."
    />
  </div>
{/snippet}

  <div class="editor-content form light">
    {#each previousComparisons(row) as value}<ContactComparisonTag {value} />{/each}
    <ContactPersonForm
    bind:value
    original={{
      displayName: draft.fieldMeta.displayName.initialValue,
      role: draft.fieldMeta.role.initialValue,
      email: draft.fieldMeta.email.initialValue,
      phone: draft.fieldMeta.phone.initialValue,
    }}
    {disabled}
    roleRequired={true}
    hints={Object.fromEntries(
      Object.entries(draft.fieldMeta).map(([field, meta]) => [
        field,
        meta.currentSource === "preconfiguration"
          ? `Aus Vorkonfiguration; ursprünglich vom Kunden: ${meta.initialValue || "Nicht genannt"}`
          : "",
      ]),
    )}
  />
    {#if error}<p role="alert" class="editor-error">{error}</p>{/if}
  </div>

<style>
  .editor-actions {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    min-width: 0;
  }
  .editor-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
    gap: 1.25rem;
    min-width: 0;
    color: var(--text-invers-100);
  }
  .editor-error {
    margin: 0;
    color: var(--error-100, #b42318);
  }
</style>
